<template>
  <div class="settings-table">
    <div class="title">
      <h5>
        Roles&nbsp;<span v-if="total">({{total}})</span>
      </h5>
      <button class="primary-btn" v-if="manageAccess" @click="addRole">
        <i class="fa fa-plus" />
        Add Role
      </button>
    </div>

    <div class="table-head" v-if="isDesktop()">
      <p class="d-left">Name</p>
      <p class="d-right">Last Modified Time</p>
      <p>Users</p>
      <p>Privileges</p>
    </div>

    <div class="table-body">
      <div v-for="(role, index) in rolesList" :key="index" class="table-row"
            @click="showRoleDetails(role.id)">
        <p class="d-left">
          {{role.name}}
        </p>
        <p class="d-right mt-right mt-grey-text">
          {{role.updated_at}}
        </p>
        <p>
          <b v-if="!isDesktop()">Users:</b>
          {{role.users_count}}
        </p>
        <p class="mt-right">
          <b v-if="!isDesktop()">Privileges:</b>
          {{role.privileges_count}}
        </p>
      </div>
    </div>

    <table-loader v-if="!total" :css="{'border-layout': !isDesktop()}" />
  </div>
</template>

<script>
import TableLoader from '@/components/global/TableLoader'

import ApiServices from '@/services/api/roles'

export default {
  name: 'ListRoles',
  components: { TableLoader },
  data () {
    return {
      rolesList: [],
      total: null,
      manageAccess: false
    }
  },
  created () {
    this.populateData()
  },
  methods: {
    populateData () {
      ApiServices.listRoles().then(response => {
        let data = response.data
        if (data) {
          this.rolesList = data.roles
          this.total = data.total
          this.manageAccess = response.privileges.manage_roles
        }
      })
    },
    showRoleDetails (id) {
      this.$router.push({name: 'RoleDetails', params: {id}})
    },
    addRole () {
      this.$router.push({name: 'RoleCreate'})
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/settingsTable.scss';

  .mobile, .tablet {
    .table-row {
      grid-template-columns: repeat(2, 1fr);
    }
  }
</style>
